import * as actionTypes from "../actionTypes";
import ReactHtmlParser from "react-html-parser";
import { store } from 'react-notifications-component';
import 'react-notifications-component/dist/theme.css';
import Messages from "../../../helper/messages";
import * as ImmersionGQL from "../../../gql";

const setLoading = (loading: boolean) => ({
    type: actionTypes.SET_LOADING,
    payload: loading
});
const getConfigurationDetailsSuccess = (items: any) => ({
    type: actionTypes.GET_CONFIGATION,
    payload: items
});
const getVdootp = (items: any) => ({
    type: actionTypes.GET_VDOOTP,
    payload: items
});
const notificationFail = (err: any, errormessage: any) => {
    let msg = Messages.NOTIFICATIONS.ERROR.someThingWrong
    if (errormessage) {
        msg = errormessage
    }
    if (err.graphQLErrors && err.graphQLErrors.length > 0) {
        msg = err.graphQLErrors[0].message;
    } else if (err.message) {
        msg = err.message;
    }
    store.addNotification({
        title: "Error!",
        message: <p>{ReactHtmlParser(msg)}</p>,
        type: "danger",
        insert: "bottom",
        container: "bottom-center",
        animationIn: ["animate__animated", "animate__fadeIn"],
        animationOut: ["animate__animated", "animate__fadeOut"],
        dismiss: {
            duration: 3000,
            onScreen: true
        }
    })
    return {
        type: actionTypes.ADD_NEW_NOTIFICATION_FAIL,
        state: msg
    }
}

export const getConfigurationDetails = (client: any, req: any) => {
    return (dispatch: any) => {
        const variables = { ...req };
        dispatch(setLoading(true));
        client.query({
            query: ImmersionGQL.queryGetCustomerConfiguration,
            fetchPolicy: "no-cache",
            variables
        })
            .then((res: any) => {
                if (res.data) {
                    dispatch(getConfigurationDetailsSuccess(res.data.getCustomerConfiguration));
                } else {
                    dispatch(notificationFail({}, res.errors[0].message))
                }
                dispatch(setLoading(false));
            })
    }
};

export const getOtpVdo = (client: any, req: any, val: any) => {
    return (dispatch: any) => {
        const variables = { ...req };
        dispatch(setLoading(true));
        client.query({
            query: ImmersionGQL.queryGetOtpVdo,
            fetchPolicy: "no-cache",
            variables
        })
            .then(async (res: any) => {
                if (res.data) {
                    const response = {
                        otp: res.data.getOtpVdo.data.otp,
                        playbackInfo: res.data.getOtpVdo.data.playbackInfo,
                        val: val
                    }
                    await dispatch(getVdootp(response));
                } else {

                    dispatch(notificationFail({}, res.errors[0].message))
                }
                dispatch(setLoading(false));
            })
    }
};